var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobsBlastIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0151 7.76562C14.0151 7.47038 14.0094 7.4065 14.0028 7.11006C13.9637 5.26705 13.9439 4.34525 13.2638 3.66276C12.5837 2.97968 11.6373 2.95623 9.74377 2.90872C8.58103 2.87938 7.41773 2.87938 6.25499 2.90872C4.36148 2.95623 3.41502 2.97968 2.73494 3.66276C2.05486 4.34525 2.03502 5.26705 1.99533 7.11006C1.98268 7.70167 1.98268 8.2935 1.99533 8.88511C2.03502 10.7281 2.05486 11.6499 2.73494 12.3324C3.41502 13.0155 4.36148 13.0389 6.25499 13.0864",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98682 4.39062L6.14365 6.75075C7.66255 7.61243 8.33722 7.61243 9.85612 6.75075L14.013 4.39062",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5987 11.304L8.15039 11.3061M14.5987 11.304L13.0955 9.80078M14.5987 11.304L13.0955 12.8073",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsBlastIcon);
export default __webpack_public_path__ + "static/media/jobs-blast-icon.23e0255ff7ce3ac4ad7d019d238ecd98.svg";
export { ForwardRef as ReactComponent };